import { Gender, MeasureComplianceStatus, PatientStatus, VisitStatus } from "../models/core"

export const MeasureComplianceStatuses = [
    MeasureComplianceStatus.IGNORED,
    MeasureComplianceStatus.COMPLIANT,
    MeasureComplianceStatus.NON_COMPLIANT
];

export const VisitStatuses = [
    VisitStatus.NEW,
    VisitStatus.IN_PROGRESS,
    VisitStatus.INACTIVE,
    VisitStatus.COMPLETED,
    VisitStatus.REFUSED,
    VisitStatus.SCHEDULED,
    VisitStatus.UTR,
];

export const PatientStatuses = [
    PatientStatus.ACTIVE,
    PatientStatus.INACTIVE,
    PatientStatus.EXCLUDED,
    PatientStatus.DONOTCONTACT,
    PatientStatus.DECEASED
];

export const Genders = [
    Gender.MALE,
    Gender.FEMALE,
    Gender.UNKNOWN
];

export const LoBs = [
    'TotalAdvantage',
    'HealthAdvantage',
    "MAP",
    "MLTC",
];

export const MeasurementNames = [
    'Care for Older Adults (COA): Functional Status Assessment',
    'Care for Older Adults (COA): Medication Review',
    'Care for Older Adults(COA): Pain Assessment',
    'Controlling High Blood Pressure (CBP)',
    'Hemoglobin A1c (HBD)',
    'Kidney Health Evaluation:(eGFR, Urine Creatinine, Urine Albumin)',
    'Transitions of Care (TRC): Medication Reconciliation Post-Discharge',
    'Hearing Exam',
    'Dental Exam',
    'Influenza Vaccine',
    'Pneumococcal Vaccine'
];

export const PhoneOutcomes = [
    'No Phone Number',
    'Out of order',
    'Rings no VM',
    'Left Message',
    'Message not left',
    'Patient hung up',
    'Scheduled',
    'Patient will call back',
    'ZCM to call the patient back',
    'Other'
];


export const TextOutcomes = [
    'Sent SMS',
    'No Cell #',
    'Message Failed',
    'No Response',
    'Scheduled',
    'Other'
];

export const EmailOutcomes = [
    'Sent Email',
    'No Email',
    'Message Failed',
    'No Response',
    'Scheduled',
    'Other'
];

export const MailOutcomes = [
    'Sent Mail',
    'No Address',
    'Mail Returned',
    'No Response',
    'Scheduled',
    'Other'
];

export const AppointmentOutcomes = [
    'Still in process of attempting to contact the member',
    'Booking in Progress',
    'Scheduled',
    'Completed',
    'Canceled',
];


export const MemberInfoUpdates = [
    'New phone number',
    'New Address',
    'New PCP',
    'New Insurance',
    'Other'
];

export const RefusalReasons = [
    'Already had services (Refused)',
    'Program not verified by PCP (Refused)',
    'Program not verified by insurance (Refused)',
    'Patient does not want a home visit (Refused)',
    'Patient refused appointment at the door (Refused)',
    'Patient hung up (Refused)',
    'Phone not in service (UTR)',
    'Phone not provided (UTR)',
    'Left messages with no response (UTR)',
    '3 attempts to call numbers provided (UTR)',
    'Unable to contact by any method (UTR)',
    'Wrong Number (UTR)'
];

export const OutcomeReasons = [
    'Patient is no longer available (Canceled)',
    'Patient is hospitalized (Canceled)',
    'Patient not feeling well (Canceled)',
    'UTR patient at appointment time (Canceled)',
    'Patient is a no-show (Canceled)',
    'Other (Canceled)',
];

export const UnknownLanguage = 'Other';
export const Languages = [
    'English', 'Spanish', 'Indian (one of)', 'Chinese', 'Ukrainian', 'Russian', UnknownLanguage
]

export const ScheduledFailedReasons = [
    'No-Show',
    'Reschedule',
    'Cancel',
    'Refused'
]

export const PhoneTypeNames = [
    'Primary Phone',
    'Secondary Phone',
    'Alt Phone',
    'TLO Phone',
    'Tevix Phone',
    'Other'
]

export const VisitReasons = [
    { name:'AWV', code:'AWV'},{ name:'CAF', code:'CAF'},{ name:'GAP', code:'GAP'},{ name:'DOH', code:'DOH'},
    { name:'Transition of Care', code:'Transition of Care'},{ name:'Follow Up', code:'Follow Up'},
    { name:'Labs', code:'Labs'}, { name:'Wound Care', code:'Wound Care'}, { name:'Dental Exam', code:'Dental Exam'},
    { name:'ABI', code:'ABI'}, { name:'Micro Albumin', code:'Micro Albumin'}, { name:'FOBT', code:'FOBT'},
    { name: 'Diabetic Retinal Exam', code:'DRE' }, { name: 'A1c', code:'A1C' }, { name: 'HRA', code:'HRA' }, 
    { name: 'At Home Audiology Exam / Hearing Aid Dispense', code:'_AHHAD' }, { name: 'Blood Pressure', code:'_BPE' }, 
    { name: 'At Home Eye Exam', code:'_HEX' },
]

export const States = [
    { name: "Alabama", code: "AL" }, { name: "Alaska", code: "AK" }, { name: "Arizona", code: "AZ" },
    { name: "Arkansas", code: "AR" }, { name: "California", code: "CA" }, { name: "Colorado", code: "CO" },
    { name: "Connecticut", code: "CT" }, { name: "Delaware", code: "DE" }, { name: "Florida", code: "FL" },
    { name: "Georgia", code: "GA" }, { name: "Hawaii", code: "HI" }, { name: "Idaho", code: "ID" },
    { name: "Illinois", code: "IL" }, { name: "Indiana", code: "IN" }, { name: "Iowa", code: "IA" },
    { name: "Kansas", code: "KS" }, { name: "Kentucky", code: "KY" }, { name: "Louisiana", code: "LA" },
    { name: "Maine", code: "ME" }, { name: "Maryland", code: "MD" }, { name: "Massachusetts", code: "MA" },
    { name: "Michigan", code: "MI" }, { name: "Minnesota", code: "MN" }, { name: "Mississippi", code: "MS" },
    { name: "Missouri", code: "MO" }, { name: "Montana", code: "MT" }, { name: "Nebraska", code: "NE" },
    { name: "Nevada", code: "NV" }, { name: "New Hampshire", code: "NH" }, { name: "New Jersey", code: "NJ" },
    { name: "New Mexico", code: "NM" }, { name: "New York", code: "NY" }, { name: "North Carolina", code: "NC" },
    { name: "North Dakota", code: "ND" }, { name: "Ohio", code: "OH" }, { name: "Oklahoma", code: "OK" },
    { name: "Oregon", code: "OR" }, { name: "Pennsylvania", code: "PA" }, { name: "Rhode Island", code: "RI" },
    { name: "South Carolina", code: "SC" }, { name: "South Dakota", code: "SD" }, { name: "Tennessee", code: "TN" },
    { name: "Texas", code: "TX" }, { name: "Utah", code: "UT" }, { name: "Vermont", code: "VT" },
    { name: "Virginia", code: "VA" }, { name: "Washington", code: "WA" }, { name: "District of Columbia", code: "DC" },
    { name: "West Virginia", code: "WV" }, { name: "Wisconsin", code: "WI" }, { name: "Wyoming", code: "WY" },
];

export const MeasureEntryList = [
    {code:'ACP', name:'Advance Care Planning (ACP)' },
    {code:'AWV', name:'Annual Wellness Visit (AWV)' },
    {code:'COA', name:'Care for Older Adults (COA)' },
    {code:'COA-MDR', name:'Care for Older Adults (COA) - Medication Review' },
    {code:'COA-FSA', name:'Care for Older Adults (COA) - Functional Status Assessment' },
    {code:'COA-PA', name:'Care for Older Adults (COA) - Pain Assessment' },
    {code:'CBP', name:'Controlling High Blood Pressure (CBP)' },
    {code:'GSD', name:'Glycemic Status Assessment for Patients with Diabetes (GSD)' },
    {code:'BPD', name:'Blood Pressure Control for Patients With Diabetes (BPD)' },
    {code:'EED', name:'Eye Exam for Patient with Diabetes (EED)' },
    {code:'HBD', name:'Hemoglobin A1c Control for Patients With Diabetes (HBD)' },
    {code:'TRC', name:'Transitions of Care (TRC)' },
    {code:'MRP', name:'Medication Reconciliation Post-Discharge (MRP)'},
    {code:'FRM', name:'Fall Risk Management (FRM)' },
    {code:'DSF-E', name:'Depression Screening and Follow-Up for Adolescents and Adults (DSF-E)' },
    {code:'DMS-E', name:'Utilization of the PHQ-9 to Monitor Depression Symptoms for Adolescents and Adults (DMS-E)' },
    {code:'ASF-E', name:'Unhealthy Alcohol Use Screening and Follow-Up (ASF-E)' },
    {code:'MSC', name:'Medical Assistance With Smoking and Tobacco Use Cessation (MSC)' },
    {code:'SPC', name:'Statin Therapy for Patients with Cardiovascular Disease (SPC)' },
    {code:'SPC|SPD', name:'Statin Therapy for Patients With Cardiovascular Disease and Diabetes (SPC, SPD)' },
    {code:'SPD', name:'Statin Therapy for Patients with Diabetes (SPD)' },
    {code:'SUPD', name:'Statin Use in Persons with Diabetes (SUPD)' },
    {code:'KED', name:'Kidney Health Evaluation for Patients With Diabetes (KED)' },
    {code:'FMC', name:'Follow-Up After Emergency Department Visit for People With Multiple High-Risk Chronic Conditions (FMC)' },
    {code:'MUI', name:'Management of Urinary Incontinence in Older Adults (MUI)' },
    {code:'PAO', name:'Physical Activity in Older Adults (PAO)' },
    {code:'BCS-E', name:'Breast Cancer Screening (BCS-E)' },
    {code:'COL-E', name:'Colorectal Cancer Screening (COL-E)' },
    {code:'AIS-E', name:'Adult Immunization Status (AIS-E)' },
    {code:'SNS-E', name:'Social Need Screening and Intervention (SNS-E)' },
];

export const ComplianceList =[
    {code:'NC', name:'Non-Compliant' },
    {code:'A', name:'Addressed' },
    {code:'C', name:'Compliant' }
];